export class Avatar {
  id: string;
  image?: string;
  content: string;
  name: string;
}
